<div class="new-claim-modal container" style="width: 500px">
  <div class="row">
    <div class="new-claim-modal__content new-claim-modal__content col-12">
      <div class="cx-dialog-header modal-header" style="height: 75px">
        <div class="cx-dialog-title modal-title">
          <div class="label-content">
            <div class="modelOs" style="font-size: 18px">
              <b
                >Thanks for confirming. You are now <br />
                creating a second claim.
              </b>
            </div>
          </div>
        </div>
        <button
          type="button"
          class="close"
          aria-label="Close"
          cxModal="dismiss"
          cxModalReason="Cross click"
          (click)="closeModal()"
        >
          <i class="fas fa-window-close"></i>
        </button>
      </div>
      <div class="cx-dialog-body modal-body" id="modellabel3">
        <div class="row">
          <div class="form-group">
            <div class="form-check">
              <input
                formControlName="accept"
                (change)="secondClaimbtn($event)"
                class="form-check-input"
                type="radio"
                value="true"
                id="defaultCheck20"
              />
              <label class="form-check-label" for="defaultCheck20" id="modellabel">Yes</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
